import { Form } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { Icon, Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.css';

const MandatAnnulantTitreAnterieurComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group className="panelRow">
					<Form.Input
						data-testid="mandatAnnulantTitreAnterieurExerRattachement"
						name="exerRattachement"
						label="Exercice"
						value={data?.exerRattachement ?? ''}
						title={data?.exerRattachement ?? ''}
						onChange={handleChange}
						width={8}
						input={{
							maxLength: 4,
						}}
					/>
					<Form.Input
						data-testid="mandatAnnulantTitreAnterieurPieceOrigine"
						name="pieceOrigine"
						label={`N° du ${data?.sens === Sens.RECETTE ? 'mandat' : 'titre'} annulé/réduit`}
						value={data?.pieceOrigine ?? ''}
						title={data?.pieceOrigine ?? ''}
						onChange={handleChange}
						width={8}
					/>
				</Form.Group>
				<Form.Group className="panelRow">
					<Form.Input
						data-testid="mandatAnnulantTitreAnterieurIdLigneOriginePes"
						name="idLigneOriginePes"
						label={`N° de la ligne de ${data?.sens === Sens.RECETTE ? 'mandat' : 'titre'}`}
						value={data?.idLigneOriginePes ?? ''}
						title={data?.idLigneOriginePes ?? ''}
						onChange={handleChange}
						width={14}
					/>
					<Form.Input
						control={Icon}
						name="caret down"
						size="large"
						circular
						width={2}
						className="panelButton"
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default MandatAnnulantTitreAnterieurComponent;
